// this file is automatically generated by git.version.ts script
export const versions = {version: '1.11.4', revision: '2ca6a3e', branch: 'HEAD'};


// WEBPACK FOOTER //
// ./src/environments/versions.ts